import React, { useContext, useEffect, useMemo } from 'react';
import { useCampaign } from '../hooks/useCampaign';

export const CampaignContext = React.createContext()

export const CampaignProvider = ({ children }) => {
    const campaignState = useCampaign();
    const value = useMemo(() => campaignState, [campaignState])

    //useEffect(() => { console.log("CampaignProvider => ", value) }, [value])

    return (
        <CampaignContext.Provider value={value}>
            {children}
        </CampaignContext.Provider>
    );
}

export function useCampaignContext() {
    return useContext(CampaignContext)
}
